/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * KnowledgeBaseIcon - Auto-generated from icon.js
 */
export const KnowledgeBaseIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M10.2669 6.63344L12 7.5V19.5L10.2669 18.6334C9.43374 18.2169 8.51506 18 7.58359 18H4C3.44772 18 3 17.5523 3 17V7C3 6.44772 3.44772 6 4 6H7.58359C8.51506 6 9.43374 6.21687 10.2669 6.63344Z" stroke="black" strokeLinejoin="round" />
		<path d="M13.7331 6.63344L12 7.5V19.5L13.7331 18.6334C14.5663 18.2169 15.4849 18 16.4164 18H20C20.5523 18 21 17.5523 21 17V7C21 6.44772 20.5523 6 20 6H16.4164C15.4849 6 14.5663 6.21687 13.7331 6.63344Z" stroke="black" strokeLinejoin="round" />
		<path d="M6 10H9.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M14.5 10H18" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M6 13H9.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M14.5 13H18" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export default KnowledgeBaseIcon;
